export default __webpack_public_path__ + "static/media/icon-facebook.229c75a0.svg";